module.exports = __webpack_public_path__ + "static/media/tool_logo_nikto.9acc1459.png";